module.exports = __webpack_public_path__ + "img/Customizable Solutions.b5b897cd.png";